import { createAsyncThunk } from '@reduxjs/toolkit';
import employeeServiceApiInstance from '../../../../config/employeeApiConfig'; 
import { LeaveType } from './leaveTypeTypes';

export const createLeaveType = createAsyncThunk(
    'leaveTypes/create',
    async (leaveTypeData: Omit<any, 'Id'>, { rejectWithValue }) => {
        try {
            const response = await employeeServiceApiInstance.post('/leavetype', leaveTypeData);
            return response.data;  
        } catch (error: any) {
            return rejectWithValue(error.response?.data || 'Failed to create leave type');
        }
    }
);

export const updateLeaveType = createAsyncThunk(
    'leaveTypes/update',
    async ({ leaveTypeId, data }: { leaveTypeId: number; data: Partial<LeaveType> }, { rejectWithValue }) => {
        try {
            const response = await employeeServiceApiInstance.put(`/leavetype/${leaveTypeId}`, data);
            return response.data;  
        } catch (error: any) {
            return rejectWithValue(error.response?.data || 'Failed to update leave type');
        }
    }
);

export const deleteLeaveType = createAsyncThunk(
    'leaveTypes/delete',
    async (leaveTypeId: number, { rejectWithValue }) => {
        try {
            const response = await employeeServiceApiInstance.delete(`/leavetype/${leaveTypeId}`);
            return response.data;  
        } catch (error: any) {
            return rejectWithValue(error.response?.data || 'Failed to delete leave type');
        }
    }
);

export const fetchLeaveTypeById = createAsyncThunk(
    'leaveTypes/fetchById',
    async (leaveTypeId: number, { rejectWithValue }) => {
        try {
            const response = await employeeServiceApiInstance.get(`/leavetype/${leaveTypeId}`);
            return response.data;  
        } catch (error: any) {
            return rejectWithValue(error.response?.data || 'Failed to fetch leave type');
        }
    }
);

export const fetchAllLeaveTypes = createAsyncThunk(
    'leaveTypes/fetchAll',
    async (_, { rejectWithValue }) => {
        try {
            const response = await employeeServiceApiInstance.get('/leavetype');
            return response.data;  
        } catch (error: any) {
            return rejectWithValue(error.response?.data || 'Failed to fetch all leave types');
        }
    }
);
